import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { CreatePasswordComponent } from './auth/create-password/create-password.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/login/login.component';
import { AdminClientsComponent } from './components/admin/admin-clients/admin-clients.component';
import { AdminHomeComponent } from './components/admin/admin-home/admin-home.component';
import { AdminListCameraComponent } from './components/admin/admin-list-camera/admin-list-camera.component';
import { AdminUsersComponent } from './components/admin/admin-users/admin-users.component';
import { MonitoringLogsComponent } from './components/admin/monitoring-logs/monitoring-logs.component';
import { ChooseAppliComponent } from './components/choose-appli/choose-appli.component';
import { ContactComponent } from './components/contact/contact.component';
import { ErrorComponent } from './components/error/error.component';
import { HelpComponent } from './components/help/help.component';
import { SmartparkingCamerasUpdateComponent } from './components/smartparking/smartparking-cameras-update/smartparking-cameras-update.component';
import { SmartparkingCamerasComponent } from './components/smartparking/smartparking-cameras/smartparking-cameras.component';
import { SmartparkingDashboardComponent } from './components/smartparking/smartparking-dashboard/smartparking-dashboard.component';
import { SmartparkingHomeComponent } from './components/smartparking/smartparking-home/smartparking-home.component';
import { SmartparkingSlotsComponent } from './components/smartparking/smartparking-slots/smartparking-slots.component';
import { CameraInfoSmartWasteComponent } from './components/smartwaste/camera-info-smart-waste/camera-info-smart-waste.component';
import { HistoriqueComponent } from './components/smartwaste/historique/historique.component';
import { MiniatureComponent } from './components/smartwaste/miniature/miniature.component';
import { SmartwasteDashboardComponent } from './components/smartwaste/smartwaste-dashboard/smartwaste-dashboard.component';
import { SmartwasteHomeComponent } from './components/smartwaste/smartwaste-home/smartwaste-home.component';
import { EditorContainerComponent } from './components/wiki/editor-container/editor-container.component';
import { ReorderContainerComponent } from './components/wiki/reorder-container/reorder-container.component';
import { SearchResultComponent } from './components/wiki/search-result/search-result.component';
import { WikiComponent } from './components/wiki/wiki.component';
import { AdminGuard } from './shared/guards/admin.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { ChangeMenuNavGuard } from './shared/guards/change-menu-nav.guard';
import { ChangePwdGuard } from './shared/guards/change-pwd.guard';
import { RoleUser } from './shared/guards/role-user';
import { superAdminGuard } from './shared/guards/superadmin.guard';
import { UnauthGuard } from './shared/guards/unauth.guard';
import { userGuard } from './shared/guards/user.guard';
import { ANPRHomeComponent } from './components/smartwaste/anpr-home/anpr-home.component';
import { AdminListAnprComponent } from './components/admin/admin-list-anpr/admin-list-anpr.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [UnauthGuard],
    data: { title: 'auth.login.title' },
  },
  {
    path: 'login/forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [UnauthGuard],
    data: { application: 'smarthub', title: 'auth.forgotPassword' },
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [ChangePwdGuard],
    data: { application: 'smarthub', title: 'auth.changePassword.title' },
  },
  {
    path: 'create-password',
    component: CreatePasswordComponent,
    canActivate: [ChangePwdGuard],
    data: { application: 'smarthub', title: 'auth.createPassword.title' },
  },
  {
    path: 'choose-appli',
    component: ChooseAppliComponent,
    canActivate: [AuthGuard, ChangeMenuNavGuard],
    data: { application: 'smarthub', title: 'choix des applis' },
  },
  {
    path: 'admin',
    canActivate: [AuthGuard, ChangeMenuNavGuard, RoleUser],
    data: { title: 'Administration', application: 'Administration' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
        data: { application: 'Administration' },
      },
      {
        path: 'home',
        component: AdminHomeComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard],
        data: { application: 'Administration' },
      },
      {
        path: 'clients',
        component: AdminClientsComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard, superAdminGuard],
        data: { application: 'Administration' },
      },
      {
        path: 'users',
        component: AdminUsersComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard],
        data: { application: 'Administration' },
      },
      {
        path: 'logs',
        component: MonitoringLogsComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard, userGuard],
        data: { application: 'Administration' },
      },
      {
        path: 'Caméras',
        component: AdminListCameraComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard],
        data: { application: 'Administration' },
      },
      {
        path: 'ANPR',
        component: AdminListAnprComponent,
        canActivate: [AuthGuard, ChangeMenuNavGuard],
        data: { application: 'Administration' },
      },
    ],
  },
  {
    path: 'smartparking',
    component: SmartparkingHomeComponent,
    canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
    data: { application: 'smartparking' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { application: 'smartparking' },
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        component: SmartparkingDashboardComponent,
        data: { application: 'smartparking' },
      },
      {
        path: 'cameras',
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        component: SmartparkingCamerasComponent,
        data: { application: 'smartparking' },
      },
      {
        path: 'cameras/update',
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        component: SmartparkingCamerasUpdateComponent,
        data: { application: 'smartparking' },
      },
      {
        path: 'slots',
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        component: SmartparkingSlotsComponent,
        data: { application: 'smartparking' },
      },
    ],
  },
  {
    path: 'smartwaste',
    component: SmartwasteHomeComponent,
    canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
    data: { application: 'smartwaste' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
        data: { application: 'smartwaste' },
      },
      {
        path: 'dashboard',
        component: SmartwasteDashboardComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
      },
      // {
      //   path: 'historique',
      //   component: HistoriqueComponent,
      //   canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
      //   data: { application: 'smartwaste' },
      // },
      {
        path: 'Timeline',
        component: MiniatureComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
      },
      {
        path: 'Camera',
        component: CameraInfoSmartWasteComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
      },
      {
        path: 'ANPR',
        component: ANPRHomeComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
      },
      {
        path: 'Wiki',
        component: WikiComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
        children: [
          {
            path: 'file/:path',
            component: EditorContainerComponent,
            data: { title: 'main.nav.links.wiki' },
          },
          {
            path: 'file',
            component: EditorContainerComponent,
            data: { title: 'main.nav.links.wiki' },
          },
          {
            path: 'search',
            component: SearchResultComponent,
            data: { title: 'main.nav.links.wiki' },
          },
          {
            path: 'reorder',
            component: ReorderContainerComponent,
            canActivate: [superAdminGuard],
            data: { title: 'main.nav.links.wiki' },
          },
          {
            path: '',
            redirectTo: 'file',
            pathMatch: 'full',
            data: { title: 'main.nav.links.wiki' },
          },
        ],
      },
      {
        path: 'Help',
        component: HelpComponent,
        canActivate: [AuthGuard, RoleUser, ChangeMenuNavGuard],
        data: { application: 'smartwaste' },
      },
    ],
  },
  {
    path: 'contact',
    component: ContactComponent,
    canActivate: [AuthGuard, ChangeMenuNavGuard],
    data: { application: 'Contact' },
  },

  { path: 'error', component: ErrorComponent, data: { title: 'error' } },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
